var _defs, _path, _polygon, _polygon2, _path2, _path3, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttomoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.82 35.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ATTOMO_WHITE_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.15,2.85,1.59,37.13H7.71L9,32.77H22.2l1.33,4.36h6.12L18.09,2.85ZM10.5,27.73l5.09-17,5.1,17Z",
    transform: "translate(-1.59 -2.02)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.9 6.12 73.84 6.12 73.84 35.11 79.48 35.11 79.48 6.12 89.47 6.12 89.47 0.83 63.9 0.83 63.9 6.12"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.51 6.12 40.45 6.12 40.45 35.11 46.08 35.11 46.08 6.12 56.07 6.12 56.07 0.83 30.51 0.83 30.51 6.12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.69,2C189.57,2,183,10.2,183,20s6.61,18,17.73,18,17.72-8.18,17.72-18S211.8,2,200.69,2Zm0,30.9c-7.6,0-11.86-5.83-11.81-12.93s4.21-12.93,11.81-12.93,11.85,5.83,11.8,12.93S208.28,32.92,200.69,32.92Z",
    transform: "translate(-1.59 -2.02)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.41,2C103.3,2,96.69,10.2,96.69,20s6.61,18,17.72,18,17.73-8.18,17.73-18S125.53,2,114.41,2Z",
    transform: "translate(-1.59 -2.02)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "156.01 27.08 145.04 0.83 139.65 0.83 139.65 35.11 145.04 35.11 145.04 12.19 153.85 35.11 158.12 35.11 166.93 12.44 166.93 35.11 172.32 35.11 172.32 0.83 166.93 0.83 156.01 27.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttomoWhite);
export default __webpack_public_path__ + "static/media/Attomo_white.ae9b81ece18e91b68c4fa86192969265.svg";
export { ForwardRef as ReactComponent };